import { useCallback } from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import withRoleCheck from "components/hocs/withRoleCheck";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import FormDialog from "components/modals/FormDialog";
import PointOfContactService from "services/PointOfContact";
import PointOfContactForm from "routes/points_of_contact/PointOfContactForm";
import {
  invalidatePointsOfContactQuery,
  usePointsOfContactTable,
} from "hooks/usePointsOfContactTable";

export const POINTS_OF_CONTACT_TABLE_CONSTANTS = {
  tableName: "Points of Contact",
  queryKey: "points_of_contact",
  className: "PointsOfContact",
  header: "Points of Contact",
  headerIcon: "user",
};

const CreatePointOfContactModal = withRoleCheck(FormDialog, [
  ACL_RELATIONSHIPS.pointOfContact.create,
]);

const PointsOfContactTableV3 = () => {
  const { columns } = usePointsOfContactTable();

  const fetchPointsOfContact = useCallback(
    async queryParams => {
      const nextQueryParams = getNextQueryParams(queryParams, columns);
      return PointOfContactService.getTable(nextQueryParams);
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      headerIcon={POINTS_OF_CONTACT_TABLE_CONSTANTS.headerIcon}
      header={POINTS_OF_CONTACT_TABLE_CONSTANTS.header}
      queryKey={POINTS_OF_CONTACT_TABLE_CONSTANTS.queryKey}
      className={POINTS_OF_CONTACT_TABLE_CONSTANTS.className}
      tableName={POINTS_OF_CONTACT_TABLE_CONSTANTS.tableName}
      createButton={
        <CreatePointOfContactModal
          onSuccess={invalidatePointsOfContactQuery}
          modelType="Point of Contact"
          FormComponent={PointOfContactForm}
        />
      }
      fetchData={fetchPointsOfContact}
      invalidateData={invalidatePointsOfContactQuery}
      enableSettings
    />
  );
};

export default PointsOfContactTableV3;
